// Unknown telemetry codes must not become an enabled tank through JS truthiness.
export const isTankEnabled = (tank) => tank?.enabled === true || tank?.enabled === 1;

// Availability is advertised per climate-zone snapshot, never by owner_zone.
// GLOBAL's own masks are not irrigation channels; aggregate its climate snapshots.
export function formatTankAvailability(controller, parent, tankId, t) {
  const zoned = Boolean(controller.zones);
  const zones = zoned ? { ...controller.zones } : { 0: parent };
  const current = Number(parent.zone_id);
  if (zoned && Number.isInteger(current) && current >= 0 && current < 9) {
    zones[current] = parent;
  }
  const entries = Object.entries(zones)
    .filter(
      ([id, zone]) => zone && Number.isInteger(Number(id)) && Number(id) >= 0 && Number(id) < 9
    )
    .sort(([a], [b]) => Number(a) - Number(b));
  const labels = [];
  let pending = entries.length === 0;
  for (const [id, zone] of entries) {
    const info = zone.settings?.irrigation_tank_info;
    if (!Array.isArray(info)) {
      pending = true;
      continue;
    }
    const tank = info.find((record) => record.tank_id === tankId);
    // A complete zone snapshot omits tanks unavailable to that zone.
    if (!tank) continue;
    if (!Array.isArray(tank.availible_in_irrigation_zones)) {
      pending = true;
      continue;
    }
    if (!isTankEnabled(tank)) {
      if (tank.enabled !== false && tank.enabled !== 0) pending = true;
      continue;
    }
    const indexes = [...new Set(tank.availible_in_irrigation_zones)]
      .filter((index) => Number.isInteger(index) && index >= 0 && index < 4)
      .sort((a, b) => a - b);
    if (!indexes.length) continue;
    const channels = `${t('irrigation')} ${indexes.map((index) => index + 1).join(', ')}`;
    const zoneName = zone.name || t('tank_zone', { zone: Number(id) + 1 });
    labels.push(zoned ? `${zoneName} – ${channels}` : channels);
  }
  if (pending) labels.push(t('tank_availability_pending'));
  return labels.join('; ') || t('tank_availability_none');
}
